import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_ES_UQ || "uq.es.styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_ES_UQ || "uqes-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_ES_UQ || 24177,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_ES_UQ || 24178,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_ES_UQ ||
    "1:160978693362:web:f65e0bc58b37074047346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-ZE07SRZ566" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.ES, LANGUAGE.EN],
  countryRegion: "Europe/Madrid",
  timeZone: {
    [LANGUAGE.ES]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    },
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2,
        "GMT+1": 1,
        "GMT+2": 2
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+1": "CET",
    "GMT+2": "CEST"
  },
  dateFormat: {
    [LANGUAGE.ES]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.ES]: "<dd>/<mm>",
    [LANGUAGE.EN]: "<dd>/<mm>"
  },
  requireDecimal: true,
  memberPricingEnabled: true
};

export default _countryEnv;
